//Check value is positive or zero
//PASS: value is valid, returns true
//FAIL: value is invalid, returns false
export const CheckValuePositive = value => value >= 0;
